import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";

import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/index";
import { QueryParamProvider } from "use-query-params";
const store = configureStore();

const NextApp = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <QueryParamProvider ReactRouterRoute={Route}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </QueryParamProvider>
    </ConnectedRouter>
  </Provider>
);

export default NextApp;
